export const UserLogin = {
	'Sign in': 'Sign in',
	'Please type your username and password':
		'Please type your username and password',
	Email: 'Email',
	'DNI or Email': 'ID number or Email',
	Password: 'Password',
	'Forgot your password?': 'Forgot your password?',
	Enter: 'Enter',
	'Stil not registered?': 'Stil not registered?',
	'Sign up here!': 'Sign up here!',
	'Too many attempts': 'Too many attempts',
	'Too many login attempts, please wait a moment':
		'Too many login attempts. Please wait a few minutes and try again.',
};
